import theme from '../../../lib/theme';
import { SliderProps } from './Slider';
import range from 'lodash/range';

const { colors, scale, font, corners, layouts } = theme;

export default ({
  minWidth,
  maxWidth,
  aspectRatio,
  brand = 'sas',
}: SliderProps) => {
  // Build a list of responsive rules.
  const responsiveStyles = {};
  range(maxWidth - minWidth + 1).forEach(i => {
    const width = minWidth + i;
    responsiveStyles[`@media (min-width: ${width}px)`] = {
      width: `${width}px !important`,
      height: `${width * aspectRatio}px !important`,
    };
  });

  return {
    slider: {
      ul: {
        ...responsiveStyles,
      },
    },
    slide: {
      ...responsiveStyles,
      backgroundSize: 'cover',
      margin: brand == 'travel360' ? '0 auto' : 'undefined',
    },
    slideBackdrop: {
      position: 'absolute',
      left: '0',
      top: '0',
      width: '100% !important',
      zIndex: '-1',
      filter: 'blur(10px)',
    },
    description: {
      backgroundColor: colors.light_grey,
      border: `1px solid ${colors.grey}`,
      padding: `${scale.xxs} ${scale.s}`,
      fontSize: 14,
      lineHeight: '1.5em',
      fontFamily: font.families.primary,
      color: '#444',
    },
    btn: {
      ...layouts.column,

      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 20,
      marginRight: 20,
      cursor: 'pointer',
      color: colors[brand].primary,
      backgroundColor: colors.white,
      borderRadius: corners.f,
      border: `1px solid ${colors.grey}`,
      transition: 'all 150ms linear',
      width: 40,
      height: 40,

      '&:hover': {
        backgroundColor: colors[brand].primary,
        color: colors.white,
        borderColor: colors[brand].primary,
      },
    },
    dots: {
      marginBottom: 20,
    },
    dot: {
      display: 'inline-block',
      cursor: 'pointer',
      width: 15,
      height: 15,
      borderRadius: 15,
      backgroundColor: 'transparent',
      border: `2px solid ${colors.white}`,
      padding: 0,
      margin: `0 ${scale.xxxs}`,
      '&:focus': {
        outline: 0,
      },
    },
    activeDot: {
      backgroundColor: `${colors.white} !important`,
    },
  };
};
